import { push } from 'react-router-redux';

const UNAUTHORIZED = 401;

const middleware = store => next => action => {
  if (action.payload && action.payload.status === UNAUTHORIZED) {
    return store.dispatch(push('/sign-in'));
  }

  return next(action);
};

export default middleware;



// WEBPACK FOOTER //
// ./src/middleware/handleNeedsAuthentication.js